import { render, staticRenderFns } from "./ItensLancamento.vue?vue&type=template&id=48544bde&"
import script from "./ItensLancamento.vue?vue&type=script&lang=js&"
export * from "./ItensLancamento.vue?vue&type=script&lang=js&"
import style0 from "./ItensLancamento.vue?vue&type=style&index=0&id=48544bde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports